import Card from 'react-bootstrap/Card'

import artifact from '@/assets/artifact.svg'
import creature from '@/assets/creature.svg'
import enchantment from '@/assets/enchantment.svg'
import instant from '@/assets/instant.svg'
import planeswalker from '@/assets/planeswalker.svg'
import salt_48 from '@/assets/salt_48.png'
import sorcery from '@/assets/sorcery.svg'
import OutboundLink from '@/components/OutboundLink/OutboundLink'
import { CommandersPageProps } from '@/types/page'

import styles from './DeckSummaryPanel.module.scss'

type Props = {
  data: CommandersPageProps['data']
}

const DeckSummaryPanel = ({ data }: Props) => {
  const deck = data?.panels.deckinfo?.deck_preview

  return (
    <Card className='flex-grow-1 shadow-sm w-100'>
      <div className='d-flex flex-column h-100 justify-content-between m-3'>
        <div className='d-flex justify-content-between'>
          {[
            { alt: 'Creatures', key: 'creature', src: creature.src },
            { alt: 'Instants', key: 'instant', src: instant.src },
            { alt: 'Sorceries', key: 'sorcery', src: sorcery.src },
            { alt: 'Artifacts', key: 'artifact', src: artifact.src },
            { alt: 'Enchantments', key: 'enchantment', src: enchantment.src },
            {
              alt: 'Planeswalkers',
              key: 'planeswalker',
              src: planeswalker.src,
            },
          ].map(({ alt, key, src }) => (
            <span key={key}>
              <img alt={alt} className={styles.type} src={src} />
              {deck && <span> {deck[key as keyof typeof deck]}</span>}
            </span>
          ))}
        </div>
        <div>{deck?.second_row}</div>
        {deck?.salt && (
          <div>
            <img alt='Salt' className={styles.type} src={salt_48.src} /> {deck.salt.toFixed(2)}
          </div>
        )}
        <div>Updated: {deck?.savedate}</div>
        {deck?.show_url && (
          <div>
            {'Source: '}
            <OutboundLink title='Deck Source' url={deck.url} utm_medium='deck_summary'>
              {deck.url.split('/')[2]}
            </OutboundLink>
          </div>
        )}
      </div>
    </Card>
  )
}

export default DeckSummaryPanel
